import { Grid } from '@material-ui/core'
import i18n from 'i18next'
import { FC } from 'react'
import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import {
  addApartmentMedia,
  confirmMedia,
  deleteApartmentMedia,
  reorderApartmentMedia
} from '../../../../actions/apartments'
import { AddApartmentMedia } from '../../../../actions/types'
import { MediaSlider } from '../../../../components/Display'
import Dialog from '../../../Dialog'
import ApartmentMediaForm from '../../Forms/ApartmentMediaForm'
import { BucketObject } from '../../../../services/storage/types'
import { MuiClasses } from '../../../../types'
import { Apartment } from '../../../../types/apartments'
import { StateInterface } from '../../../../types/states'
import { bindSubmitActionToPromise } from '../../../../utils/forms'
import { selectIsMobile } from '../../../../selectors/users'

interface AddressAndMediaProps {
  files: BucketObject[]
  classes: MuiClasses
  apartment: Apartment
  t: i18n.TFunction
}

interface MediaDialogButtonOwnProps {
  t: i18n.TFunction
  classes: MuiClasses
  apartment: Apartment
  files: BucketObject[]
  buttonClassName?: string
}

interface MediaDialogButtonDispatchProps {
  addApartmentMediaFiles: AddApartmentMedia
  deleteMedia: (key: string) => void
  reorderMedia: ({
    oldIndex,
    newIndex
  }: {
    oldIndex: number
    newIndex: number
  }) => void
  doConfirmMedia: () => void
}

interface MediaDialogButtonStateProps {
  isMobile: boolean
}

type MediaDialogButtonProps = MediaDialogButtonOwnProps &
  MediaDialogButtonDispatchProps &
  MediaDialogButtonStateProps

const MediaDialogButtonComponent: FC<MediaDialogButtonProps> = ({
  t,
  classes,
  apartment,
  files,
  addApartmentMediaFiles,
  deleteMedia,
  reorderMedia,
  doConfirmMedia,
  isMobile,
  buttonClassName
}) => (
  <Dialog
    fullScreenDialogMobile={true}
    dialogId='addMediaDialog'
    buttonClassName={buttonClassName || classes.primaryBtn}
    buttonLabel={t('apartment.mediaUpload.addImages')}
    title={t('apartment.mediaUpload.addImages')}
    maxWidth='lg'
    color='primary'
    Content={
      <ApartmentMediaForm
        deleteMedia={deleteMedia}
        reorderMedia={reorderMedia}
        addApartmentMedia={addApartmentMediaFiles}
        files={files}
        media={apartment.media}
        confirmMedia={doConfirmMedia}
        isMobile={isMobile}
      />
    }
  />
)

const mapStateToProps = (state: StateInterface): MediaDialogButtonStateProps => ({
  isMobile: selectIsMobile(state)
})

const mapDispatchToProps = (dispatch: Dispatch): MediaDialogButtonDispatchProps => ({
  addApartmentMediaFiles: bindSubmitActionToPromise(dispatch, addApartmentMedia),
  deleteMedia: (fileKey: string) => dispatch(deleteApartmentMedia(fileKey)),
  reorderMedia: ({
    oldIndex,
    newIndex
  }: {
    oldIndex: number
    newIndex: number
  }) => dispatch(reorderApartmentMedia({ oldIndex, newIndex })),
  doConfirmMedia: () => dispatch(confirmMedia())
})

const MediaDialogButton = connect(
  mapStateToProps,
  mapDispatchToProps
)(MediaDialogButtonComponent)

const AddressAndMedia: FC<AddressAndMediaProps> = ({
  files,
  t,
  classes,
  apartment
}) => (
  <Grid container direction='column' className={classes.addressAndMedia}>
    <Grid item className={classes.mediaSliderContainer}>
      <MediaSlider
        t={t}
        files={files}
        media={apartment.media}
        imageBackground='transparent'
        fullWidthImages
        showDots={false}
      />
    </Grid>
  </Grid>
)

export { MediaDialogButton }
export default AddressAndMedia
